import { gql } from "@apollo/client";

export const GET_ADMINTRANSACTION_DETAILS_WEBOOK = gql`
  query lookupMissingTransactionViaWebHook(
    $transactionid: String!
    $verification: String!
    $awarded: Boolean
  ) {
    lookupMissingTransactionViaWebHook(
      transactionid: $transactionid
      verification: $verification
      awarded: $awarded
    ) {
      status
      error
      customer {
        firstname
        lastname
        address1
        address2
        city
        state
        zip
        phone
        email
        customerid
        datetimecreated
      }
      transaction {
        ctransid
        gateway
        referenceid1
        datetimecreated
        price
        invoicenumber
        shortdescription
      }
    }
  }
`;

export const GET_ADMIN_GET_DISPUTED_TRANSACTION_REPORT = gql`
  query getDisputedTransactionReport(
    $dateDisputedStartRange: String
    $dateDisputedEndRange: String
    $limit: Float
  ) {
    getDisputedTransactionReport(
      dateDisputedStartRange: $dateDisputedStartRange
      dateDisputedEndRange: $dateDisputedEndRange
      limit: $limit
    ) {
      status
      error
      customers {
        customerid
        referenceid1
        firstname
        lastname
        phone
        numOfDisputes
        totalDisputedAmount
      }
      distributors {
        referenceid1
        numOfDisputes
        totalDisputedAmount
        numOfDisputesWon
        totalDisputedAmountWon
        numOfDisputesLost
        totalDisputedAmountLost
      }
      customerNumOfDisputes
      customerTotalDisputedAmount
      distributorNumOfDisputes
      distributorTotalDisputedAmount
      distributorNumOfWonDisputes
      distributorTotalWonDisputedAmount
      distributorNumOfLostDisputes
      distributorTotalLostDisputedAmount
    }
  }
`;

export const GET_ADMIN_PROCESSOR_STATUS_REPORT = gql`
  query adminGetProcessorStatusReport($startDateTime: String!, $endDateTime: String!) {
    adminGetProcessorStatusReport(startDateTime: $startDateTime, endDateTime: $endDateTime) {
      status
      error
      processors {
        paymentid
        name
        referrals {
          code
          count
          total
        }
      }
    }
  }
`;
